import { Navigate, type RouteObject } from 'react-router-dom';
import { ObserverPage } from '../observer/ObserverPage';
import { authRoutes } from './authRoutes';
import { LoginPage } from './LoginPage';
import { OnboardPage } from './onboard/OnboardPage';
import { RegisterPage } from './RegisterPage';

/**
 * Маршрути екранів входу (поза оболонкою простору, прототип v4 screens login · register · onboard і режим спостерігача): /login, /register,
 * /onboarding, /observe; стара адреса /new-workspace веде на /onboarding.
 */
export const entryRoutes: RouteObject[] = [
  { path: authRoutes.login(), element: <LoginPage /> },
  { path: authRoutes.register(), element: <RegisterPage /> },
  { path: authRoutes.onboarding(), element: <OnboardPage /> },
  { path: authRoutes.observe(), element: <ObserverPage /> },
  { path: '/new-workspace', element: <Navigate to={authRoutes.onboarding()} replace /> },
];
